module.exports = __webpack_public_path__ + "img/reupload.f6b4aa92.svg";